import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Spin} from "antd";
import {PlayCircleFilled, UserOutlined, LoadingOutlined, VideoCameraOutlined} from '@ant-design/icons';
import { STREAM_SERVER, FINDING_STREAM_SERVER } from "./config";
import './MatchInfo.css';

export async function sendGetRequest(link) {
    const res = await axios.get(link);
    const data = res.data;
    return data.data;
}

const MatchInfo = ({matchId, urls, referer, isVebo, linkId, slug}) => {
    const [playUrls, setPlayUrls] = useState([])
    const [loading, setLoading] = useState(false);

    const fetchMatchInfos = async (id) => {
        setLoading(true)
        try {
            const links = await sendGetRequest(`${FINDING_STREAM_SERVER}/tc/match/${slug}`);
            if (!links?.play_urls || links.play_urls.length === 0) {
                throw new Error("no links")
            }
            setPlayUrls(links?.play_urls);
        } catch (error) {
            try {
                const hoiquantvLinks = await sendGetRequest(`${STREAM_SERVER}/hoiquantv/streams/${slug}`);
                if (hoiquantvLinks?.play_urls?.length > 0) {
                    setPlayUrls(hoiquantvLinks.play_urls);
                }
            } catch (e) {
                console.log('No streams found from hoiquantv');
            }
        } finally {
            setLoading(false)
        }
    }

    const fetCKLinks = async (linkId) => {
        setLoading(true)
        const links = await sendGetRequest(`${STREAM_SERVER}/ck/links?url=${linkId}`);
        setPlayUrls(links?.play_urls)
        setLoading(false)
    }

    useEffect(() => {
        if (urls?.length) {
            setPlayUrls(urls)
        } else if (isVebo)
            fetchMatchInfos(matchId)
        else {
            fetCKLinks(linkId)
        }
    }, [matchId, urls, linkId]);

    // Group streams by Source → BLV → Qualities
    const groupStreams = (streams) => {
        const groups = {};
        streams.forEach(stream => {
            const source = stream.source || 'Unknown';
            const blv = stream.blv || 'Unknown';

            if (!groups[source]) {
                groups[source] = {};
            }
            if (!groups[source][blv]) {
                groups[source][blv] = [];
            }
            groups[source][blv].push(stream);
        });
        return groups;
    };

    const groupedStreams = groupStreams(playUrls || []);
    const sourceNames = Object.keys(groupedStreams);

    const handlePlay = (stream) => {
        const url = stream.flvSrc || stream.url;
        const viewParams = new URLSearchParams({
            url,
            referer: stream.referer || referer || '',
        });
        window.open(`${window.location.origin}/view?${viewParams.toString()}`, "_blank");
    };

    if (loading) {
        return (
            <div className="stream-modal-loading">
                <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} />
                <span>Finding streams...</span>
            </div>
        );
    }

    if (sourceNames.length === 0) {
        return (
            <div className="stream-modal-empty">
                <VideoCameraOutlined />
                <span>No streams available</span>
                <p>Check back closer to match time</p>
            </div>
        );
    }

    return (
        <div className="stream-modal">
            <div className="stream-modal-header">
                <span className="stream-count">{playUrls.length} streams available</span>
            </div>

            <div className="stream-list">
                {sourceNames.map(source => (
                    <div key={source} className="stream-source">
                        <div className="stream-source-header">
                            <span>{source}</span>
                        </div>

                        {Object.keys(groupedStreams[source]).map(blv => (
                            <div key={blv} className="stream-group">
                                <div className="stream-blv">
                                    <UserOutlined />
                                    <span>{blv}</span>
                                </div>
                                <div className="stream-qualities">
                                    {groupedStreams[source][blv].map((stream, index) => (
                                        <button
                                            key={stream.id || index}
                                            className="stream-btn"
                                            onClick={() => handlePlay(stream)}
                                        >
                                            <PlayCircleFilled />
                                            <span className="quality-label">{stream.quality || 'HD'}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MatchInfo;
